import type { AppIconProps } from '../Icons.types';

export const AppBooksIcon = (props: AppIconProps) => {
  const { className, ...rest } = props;

  return (
    <svg
      {...rest}
      className={className}
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.93294 1.43338C3.93294 1.21237 3.84515 1.00041 3.68887 0.844129C3.53258 0.687849 3.32062 0.600052 3.09961 0.600052H1.43294C1.21193 0.600052 0.999968 0.687849 0.843687 0.844129C0.687407 1.00041 0.599609 1.21237 0.599609 1.43338V13.1001C0.599609 13.3211 0.687407 13.533 0.843687 13.6893C0.999968 13.8456 1.21193 13.9334 1.43294 13.9334H3.09961C3.32062 13.9334 3.53258 13.8456 3.68887 13.6893C3.84515 13.533 3.93294 13.3211 3.93294 13.1001M3.93294 1.43338V13.1001M3.93294 1.43338C3.93294 1.21237 4.02074 1.00041 4.17702 0.844129C4.3333 0.687849 4.54526 0.600052 4.76628 0.600052H6.43294C6.65396 0.600052 6.86592 0.687849 7.0222 0.844129C7.17848 1.00041 7.26628 1.21237 7.26628 1.43338V13.1001C7.26628 13.3211 7.17848 13.533 7.0222 13.6893C6.86592 13.8456 6.65396 13.9334 6.43294 13.9334H4.76628C4.54526 13.9334 4.3333 13.8456 4.17702 13.6893C4.02074 13.533 3.93294 13.3211 3.93294 13.1001M0.599609 3.93338H3.93294M3.93294 10.6001H7.26628M8.09961 4.76672L11.4329 3.93338M9.76628 10.6001L13.0354 9.78338M7.93546 1.06672L9.75546 0.625052C10.2238 0.512552 10.6996 0.783385 10.8238 1.23505L13.903 12.4167C13.9573 12.6214 13.9332 12.839 13.8355 13.0269C13.7378 13.2148 13.5734 13.3595 13.3746 13.4326L13.2638 13.4667L11.4438 13.9084C10.9755 14.0209 10.4996 13.7501 10.3755 13.2984L7.29629 2.11672C7.24197 1.91201 7.26602 1.69439 7.36375 1.5065C7.46148 1.3186 7.62583 1.17395 7.82462 1.10088L7.93546 1.06672Z"
        stroke="#737781"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
